import { Form } from "antd";

export default function Email({ form }) {
  return <Form layout="vertical" name="taskForm" form={form}></Form>;
}
